

// Custom function for replacing bg image according to item selected in menu
$(document).ready(function(){

	var currentBG = $(".component-steps .active").attr("data-background");
	$(".laptop-screen").addClass("" + currentBG + "");

	$(".component-steps .span12").click(function(){

	var bgurl = $(this).attr("data-background");
		$(".component-steps .span12").removeClass("active");
		$(this).addClass("active");

		$(".laptop-screen").removeClass (
			function (index, css) {
				return (css.match (/(^|\s)bg-\S+/g) || []).join(' ');
				}
			).addClass("" + bgurl + "");		
	});
});


// Script for reviews section
(function(){
	/**
	 * Convert radio buttons to stars
	 * @version 1.0.0
	 * @author Aleš Gabriel <gabriel@avast.com>
	 * @module avast.web.rating
	 * @param {NodeList} Array of radio button elements
	 * @returns Object of methods
	 */
	avm.define('avast.web.rating', function(radios){
		return {
			radios: radios,
			stars: function(){
				var rating = this,
					allStars = $('<div class="rating-stars">'),
					radios = this.radios,
					stars = [];

				this.allStars = allStars;

				radios.forEach(function(radio, index, array){
					stars.push($('<div class="rating-star selected">').data('value', radio.value).get(0));
				});

				allStars.on('click', '.rating-star', function(){
					rating.rateClick.apply(rating, arguments); // TODO: Or function.bind()? Support for forEach and bind is almost the same
				});
				allStars.append(stars);

				if(allStars.length){
					this.hideRadios(radios);
				}

				return allStars;
			},
			rateClick: function(evt){
				var star = $(evt.currentTarget);

				this.lightUpStars(star);
				this.rateOnRadios(star.data('value'), this.radios);
			},
			hideRadios: function(radios){
				$(radios).hide();
			},
			lightUpStars: function(star){
				star.siblings().addBack().removeClass('selected');
				star.prevAll().addBack().addClass('selected');
			},
			rateOnRadios: function(value, radios) {
				$(radios).filter('[value=' + value +']').prop('checked', true);
			},
			destroy: function(){
				$(this.radios).show();
				this.allStars.off('click');
				this.allStars.remove();
			}
		}
	})

	/**
	 * Parse JSON to microdata reviews
	 * @version 1.0.0
	 * @author Aleš Gabriel <gabriel@avast.com>
	 * @module avast.web.review
	 * @returns Object of methods
	 * @description Expected JSON data structure:
		[
			{
				"date": "2015-10-24T04:43:04.8019109Z",
				"name": "n",
				"rating": 4,
				"text": "this is the best antivirus"
			}
		]
	 */
	/*
	avm.define('avast.web.review', (function(data){
			return {
				reviews: data ?  JSON.parse(data) : JSON.parse(document.getElementById('avast-adc-reviews').innerHTML),
				fetch: function(from, to){
					var ratings = [],
						from = from || 0,
						to = to || this.reviews.length,
						reviews = this.reviews.slice(from, to);

						reviewsDOM = $.map(reviews, function(review){
							var d = new Date(review.date)
								var day = d.getDate();
								var month = d.getMonth() + 1;
								var year = d.getFullYear();

							var prefix = 'slider-review-',
								slide = $('<div itemscope itemtype="http://schema.org/Review">').addClass(prefix + 'slide'),

								thing = $('<div itemprop="itemReviewed" itemscope itemtype="http://schema.org/Product">').addClass(prefix + 'thing'),
								thingValue = $('<span itemprop="name">AVS</span>').text('Avast Free Antivirus for Windows 10'),
								name = $('<div itemprop="author" itemscope itemtype="http://schema.org/Person">').addClass(prefix + 'author'),
								nameValue = $('<span itemprop="name">').text(review.name),
								rating = $('<div itemprop="reviewRating" itemscope itemtype="http://schema.org/Rating">').addClass(prefix + 'rating'),
								ratingValue = $('<span itemprop="ratingValue">').text(review.rating),
								stars = new Array(review.rating)
								text = $('<p itemprop="reviewBody">').addClass(prefix + 'text').text(review.text),
								date = $('<span itemprop="datePublished">').text(day + '/' + month + '/' + year).addClass(prefix + 'date');

							for (var i = 0; i < parseInt(review.rating); i++){
								rating.append('<span class="star">');
							}

							slide.append([thing.append(thingValue), name.append(nameValue), date, rating.append(ratingValue), text]);
							ratings.push(parseInt(review.rating));

							return slide;
						});

						return reviewsDOM;
				}

			}
	})());
	*/

	var router = avm.require('avast.web.router');
	router.set({
		rate: function(){
			var $ = avm.require('jquery'),
				timeout;

			$.colorbox({
				inline: true,
				width: 570,
				height: 600,
				initialHeight: 600,
				href: '#ratingPopup',
				className: 'rating-form',
				onLoad: function(){
					var url = avastGlobals.web.RootPath ? avastGlobals.web.RootPath + 'rating-form.php' : 'rating-form.php';

					$("#ratingForm").load(url, function(){
						var rating = avm.require('avast.web.rating')($('.rating-form').find('input[type="radio"][name="rating"]').get()),
							stars = rating.stars(),
							target = document.querySelector('#colorbox.rating-form .form-table');

						initAvastForm();

						$('#colorbox.rating-form').find('input[type="radio"][name="rating"]')
							.closest('.form-item')
							.hide()
							.before($('<div>').addClass('form-item').append(stars));

						$.colorbox.resize();
						// Form tweaks
						$('#colorbox.rating-form').find('#frm-text').attr('maxlength', '300');

						//console.log('mutation target %o', target);
						// create an observer instance
						if(typeof MutationObserver === 'function') {
							var observer = new MutationObserver(function(mutations) {
								mutations.forEach(function(mutation) {
									//console.log(mutation.type);
									//console.log($(target).has('.bubble'));

									if(mutation.type === 'childList' && $(target).has('.bubble')){
										// Autoclose
										timeout = setTimeout(function() {
											$.colorbox.close();
											clearTimeout(timeout);
										}, 5000);
									}
								});
							});

							// configuration of the observer:
							var config = {
								childList: true
							}

							// pass in the target node, as well as the observer options
							var oTimeout = setTimeout(function() {
								//console.log('mutation target %o', target);
								observer.observe(target, config);
								clearTimeout(oTimeout)
							}, 0);
						}
					});

				},
				onClosed: function(){
					clearTimeout(timeout);
					// hash for tracking closed popup
					window.location.hash = '!';
				}
			});
		}
	});
})();

$(document).ready(function(){
	//console.time('buildSlides')
	/*var reviewModule = avm.require('avast.web.review');
		reviews = reviewModule.reviews;*/
		bxFetchSlide = 0,
		ratingPoints = 5;

	// Open rating form

	// Slider
	var bxslider = $('.js-slider')
		//.empty()
		//.append(reviewModule.fetch(0, 21))
		.bxSlider({
			auto: false,
			controls: true,
			pager: false,
			infiniteLoop: true,
			//hideControlOnEnd: true,
			minSlides: 3,
			maxSlides: 3,
			slideMargin: 60,
			slideWidth: 330,
			nextSelector: '.arrow-box.arrow-right',
			nextText: '',
			prevSelector: '.arrow-box.arrow-left',
			prevText: '',
			/*onSlideNext: function(slider, index, oldIndex){
				var last = bxslider.getSlideCount();
					from = (bxFetchSlide + 1) * 3;
					to =  (bxFetchSlide + 8) * 3;

				if (bxFetchSlide) {
					//console.log('from: %s', from)
					//console.log('to: %s', to)

					$('.slider-reviews').addClass('is-loading')
					$('.js-slider').append(reviewModule.fetch(from, to));
					bxslider.reloadSlider();
				}

				if (((bxslider.getCurrentSlide() + 1) * 3) >= bxslider.getSlideCount()) {
					// Prepare to reload but reload with next slide
					bxFetchSlide = bxslider.getCurrentSlide();
				}

			},*/
			onSliderLoad: function(){
				var timeout;

				if (bxFetchSlide) {
					//console.log('onSliderLoad')
					//console.log('onSliderLoad count: %s', bxslider.getSlideCount())

					// It's too early to move on correct position. For some reason the width is still not correctly recalculated.
					timeout = setTimeout(function(){
						bxslider.goToSlide(bxFetchSlide + 1);

						// @todo: remove loader

						// Clear state
						bxFetchSlide = 0;

						// Clear timeout
						clearTimeout(timeout);
					}, 0)
				}
			}
			/*onSlideAfter: function(){
				$('.slider-reviews').removeClass('is-loading');
			}*/
		});

	// Total reviews and average rating to DOM
	/*var totalRatings = reviews.reduce(function(pv, cv) { return pv + cv.rating; }, 0);
	var avgRating = (totalRatings) / reviews.length;
	var percentAvgRating = Math.floor((100 / ratingPoints) * avgRating);

	$('.rating-bar').width(17 * ratingPoints);
	$('.rating-bar-average').width(percentAvgRating + '%');

	$('.total-reviews').text(reviews.length)
	$('.average-rating').text(avgRating.toPrecision(2))*/
	//console.timeEnd('buildSlides')
});
// /Script for reviews section